export interface ResponseInterface {
  status: boolean;
  message: null;
  data: ResponseSearchRecommendedInterface[];
}

export interface ResponseSearchRecommendedInterface {
  id: string;
  keyword_id: string;
  table_slug: string;
  table_slug_text: string;
  latitude: string;
  longtitude: string;
  display_name: string;
  css_class: string;
  img_icon: string;
  language: string;
  sort: string;
  location_id: null;
  iso_code_2a: string;
  airport_nearby: null;
  country_id: number;
  city_id: number;
  area_id: null;
  area_alias: null;
  city_name: string;
  city_alias: null;
  country_name: string;
  country_alias: null;
  country_slug: string;
  slug: string;
  airport_name: string;
  airport: Airport;
  destination_id: null;
  totalcount: number;
}

interface Airport {
  type: null;
  descriptor: string;
}

export class GetDestinationsRecommended {
  public status: boolean = false;

  public message: null | string = "";

  public data: ResponseSearchRecommendedInterface[] | null = null;

  constructor(data: unknown) {
    const newType = data as ResponseInterface;
    this.status = !!newType.status;
    this.data = newType.data || null;
    this.message = newType.message || "";
  }
}
